import { Component, OnInit, Inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-alumni-feedback-list',
  templateUrl: './alumni-feedback-list.component.html',
  styleUrls: ['./alumni-feedback-list.component.scss']
})
export class AlumniFeedbackListComponent implements OnInit {

  constructor(private http: HttpClient, @Inject('API_ENDPOINT') private api_endpoint: string) { }

  public lists =[];

  ngOnInit() {
    this.http.get<any>(this.api_endpoint+'/alumnifeedback/').subscribe(
      data => {
        this.lists = data.data;
    },
    (err: HttpErrorResponse) => {
      if (err.error instanceof Error) {
        console.log("Client-side error occured.");
      } else {
        console.log("Server-side error occured.");
      }
  });
  }


}
